// Rabattstufen fuer Kunden mit eigener Kundenkarte (IRB, "Sofortrabatt" nach
// Bonsumme). Bis 22.10.2026 fest im Code (CBonManager): ab 100 Euro 5 %, ab
// 200 Euro 7 %, ab 500 Euro 10 % - genau das bleibt die Voreinstellung.
// Pro Kasse in var/etc/ini.txt uebersteuerbar:
//   Rabattstufen 100:5,200:7,500:10   (ab Betrag:Prozent, aufsteigend)
//   Rabattstufen AUS                  (keine Stufen)
// Ein Leerzeichen im Wert geht nicht - der ini-Leser nimmt nur das zweite Wort.

export var RABATTSTUFEN_VOREINSTELLUNG = "100:5,200:7,500:10";

// Liefert [{min, max, percent}], max der letzten Stufe = false (nach oben offen).
// Unlesbarer Wert: Voreinstellung + Warnung im Log.
export function parseRabattstufen(text) {
    var wert = String(text == null || text === 0 ? "" : text).trim();
    if (!wert) wert = RABATTSTUFEN_VOREINSTELLUNG;
    if (/^(AUS|NEIN|NO|0)$/i.test(wert)) return [];

    var stufen = [];
    var teile = wert.split(",");
    for (var i = 0; i < teile.length; i++) {
        var m = /^\s*(\d+(?:[.]\d+)?)\s*:\s*(\d+(?:[.]\d+)?)\s*$/.exec(teile[i]);
        if (!m || (stufen.length && parseFloat(m[1]) <= stufen[stufen.length - 1].min)) {
            if (typeof log != "undefined") log.add(2, "Warning", "Rabattstufen unlesbar", wert + " - es gilt " + RABATTSTUFEN_VOREINSTELLUNG);
            return parseRabattstufen(RABATTSTUFEN_VOREINSTELLUNG);
        }
        stufen.push({ min: parseFloat(m[1]), max: false, percent: parseFloat(m[2]) });
    }
    for (var j = 0; j < stufen.length - 1; j++)
        stufen[j].max = stufen[j + 1].min;
    return stufen;
}
